"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.BUTTON_TYPE = exports.BUTTON_STYLE_TYPE = exports.BUTTON_SIZE = exports.BUTTON_ICON_POSITION = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
require("./Button.scss");
var _excluded = ["children", "iconPosition", "buttonRef", "onClick", "onTouchEnd", "href", "role", "tabIndex", "title", "isLoading", "isActive", "isDisabled", "isFullWidth", "size", "styleType", "type", "renderDiv", "className", "dataAttributes"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var BUTTON_SIZE = /*#__PURE__*/function (BUTTON_SIZE) {
  BUTTON_SIZE["default"] = "default";
  BUTTON_SIZE["small"] = "small";
  return BUTTON_SIZE;
}(BUTTON_SIZE || {});
exports.BUTTON_SIZE = BUTTON_SIZE;
var BUTTON_STYLE_TYPE = /*#__PURE__*/function (BUTTON_STYLE_TYPE) {
  BUTTON_STYLE_TYPE["primary"] = "primary";
  BUTTON_STYLE_TYPE["secondary"] = "secondary";
  BUTTON_STYLE_TYPE["ghost"] = "ghost";
  BUTTON_STYLE_TYPE["light"] = "light";
  BUTTON_STYLE_TYPE["negative"] = "negative";
  BUTTON_STYLE_TYPE["blank"] = "blank";
  return BUTTON_STYLE_TYPE;
}(BUTTON_STYLE_TYPE || {});
exports.BUTTON_STYLE_TYPE = BUTTON_STYLE_TYPE;
var BUTTON_ICON_POSITION = /*#__PURE__*/function (BUTTON_ICON_POSITION) {
  BUTTON_ICON_POSITION["left"] = "left";
  BUTTON_ICON_POSITION["right"] = "right";
  return BUTTON_ICON_POSITION;
}(BUTTON_ICON_POSITION || {});
exports.BUTTON_ICON_POSITION = BUTTON_ICON_POSITION;
var BUTTON_TYPE = /*#__PURE__*/function (BUTTON_TYPE) {
  BUTTON_TYPE["button"] = "button";
  BUTTON_TYPE["submit"] = "submit";
  return BUTTON_TYPE;
}(BUTTON_TYPE || {});
exports.BUTTON_TYPE = BUTTON_TYPE;
var Button = function Button(_ref) {
  var _classNames;
  var children = _ref.children,
    iconPosition = _ref.iconPosition,
    buttonRef = _ref.buttonRef,
    onClick = _ref.onClick,
    onTouchEnd = _ref.onTouchEnd,
    href = _ref.href,
    role = _ref.role,
    tabIndex = _ref.tabIndex,
    title = _ref.title,
    isLoading = _ref.isLoading,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isFullWidth = _ref.isFullWidth,
    isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? BUTTON_SIZE["default"] : _ref$size,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? BUTTON_STYLE_TYPE.primary : _ref$styleType,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? BUTTON_TYPE.button : _ref$type,
    renderDiv = _ref.renderDiv,
    className = _ref.className,
    dataAttributes = _ref.dataAttributes,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isButtonDisabled = isLoading || isDisabled;
  var rootClassName = (0, _classnames["default"])('cds-Button', "cds-Button--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType)), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "cds-Button--".concat((0, _upperCaseFirst.upperCaseFirst)(size || '')), size !== BUTTON_SIZE["default"]), (0, _defineProperty2["default"])(_classNames, 'cds-Button--Active', isActive), (0, _defineProperty2["default"])(_classNames, 'cds-Button--FullWidth', isFullWidth), (0, _defineProperty2["default"])(_classNames, "cds-Button--Icon".concat((0, _upperCaseFirst.upperCaseFirst)(iconPosition || '')), iconPosition), _classNames), className);
  var commonProps = _objectSpread(_objectSpread({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes)), {}, {
    role: role,
    tabIndex: tabIndex,
    'aria-checked': props['aria-checked'],
    'aria-labelledby': props['aria-labelledby']
  });
  if (renderDiv) {
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, commonProps, {
      className: "cds-ButtonExternalLink",
      ref: buttonRef
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: rootClassName
    }, children));
  }
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({}, commonProps, {
      className: "cds-ButtonExternalLink",
      ref: buttonRef,
      href: href
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: rootClassName
    }, children));
  }
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, commonProps, {
    ref: buttonRef,
    className: rootClassName,
    disabled: isButtonDisabled,
    type: type,
    onClick: onClick,
    onTouchEnd: onTouchEnd,
    title: title
  }), isLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Button-Loader"
  }), children);
};
exports.Button = Button;
Button.config = {
  iconPosition: BUTTON_ICON_POSITION,
  size: BUTTON_SIZE,
  styleType: BUTTON_STYLE_TYPE,
  type: BUTTON_TYPE
};